
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-button-select-renderer-handsfree-operations',
    template: `
  <style>
  .row-action-btns {
    min-width: 70px;
    }
  </style>

   
    <div class="row-action-btns" *ngIf="isAutoOperation()">
        <button title="Replace PO" style="background-color: #10ce9c;" mat-mini-fab color="primary" (click)="onClickPO($event)">
            <mat-icon>list</mat-icon>
        </button>
        <button title="Replace Product" style="background-color: #0f0fd1; margin-left: 15px;" mat-mini-fab color="primary" (click)="onClickProduct($event)">
            <mat-icon>view_list</mat-icon>
        </button>
    </div>
    `
})

export class btnrendererHandsfrreeOpertionsComponent implements ICellRendererAngularComp {

    params: any;
    label!: string;

    agInit(params: any): void {
        this.params = params;
        this.label = this.params.label || null;
    }

    refresh(params?: any): boolean {
        return true;
    }

    onClickPO($event: any) {
        if (this.params.onClickPO instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            }
            this.params.onClickPO(this.params);

        }
    }

    onClickProduct($event: any) {
        if (this.params.onClickProduct instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            }
            this.params.onClickProduct(this.params);

        }
    }

    isAutoOperation(): boolean {
        return this.params?.node?.data?.Remarks?.toString().toLowerCase() == 'auto no po';
    }
}